import { constants } from "@newsela/angelou";

const { colors } = constants;
const darkGrey = colors.ui.neutral[700];
const white = colors.ui.white[700];

const fillColor = (useDarkGrey) => {
  return {
    fill: useDarkGrey ? darkGrey : white,
  };
};

export const numberCorrectCss = (isMaxPoints) => {
  return {
    fontSize: "3rem",
    ...fillColor(isMaxPoints),
  };
};

export const countCss = (isMaxPoints) => {
  return {
    fontSize: "1.5rem",
    ...fillColor(isMaxPoints),
  };
};

export const pointsCss = (isMaxPoints) => {
  return {
    fontSize: "3rem",
    ...fillColor(isMaxPoints),
  };
};

export const correctCss = (isMaxPoints = false) => {
  return {
    fontSize: "1rem",
    ...fillColor(isMaxPoints),
  };
};
